module.exports = __webpack_public_path__ + "img/APA 1975.c9fd2294.png";